
import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { X, Eye, EyeOff } from "lucide-react";
import "../../../../assets/css/components/customer/auth/loginmodal/LoginModal.css";
import { useNavigate, useLocation } from "react-router-dom";
import AppContext from "../../../../context/AppContext";
import Swal from 'sweetalert2';
const LoginModal = ({ isOpen, onClose, onLoginSuccess }) => {


  const { baseUrl, setAuthToken, RegExpChecker } = useContext(AppContext);

  const navigate = useNavigate();
  const location = useLocation();


  const [isLogin, setIsLogin] = useState(true);
  const [showPassword, setShowPassword] = useState(false);

  const [form, setForm] = useState({});
  const [fullName, setFullName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("password");


  // ================= SIGNUP =================
const handleSignup = () => {

    setLoading(true);

    const formData = new FormData();

    formData.append("fullName", fullName);
    formData.append("phoneNumber", phoneNumber);
    formData.append("email", email);
    formData.append("password", password);

    axios.post(`${baseUrl}/customersignup`, formData)

    .then((res)=>{

        setLoading(false);

        if(res.data.success){

            localStorage.setItem("authToken",res.data.token);

            setAuthToken(res.data.token);

            localStorage.setItem("customerLoggedIn","true");

            localStorage.setItem("email",email);

           localStorage.setItem("password", res.data.customer.password);
           localStorage.setItem(
    "customer",
    JSON.stringify(res.data.customer)
);

            navigate("/customer-dashboard");

            onLoginSuccess && onLoginSuccess();
        }

    })

    .catch((err)=>{

        setLoading(false);

        const message = err.response?.data?.message;

        setErrors({
            email: message === "Email already exists." ? message : ""
        });

    });

};


  // ================= LOGIN =================
const handleLogin = () => {

    setLoading(true);

    const formData = new FormData();

    formData.append("email",email);

    formData.append("password",password);
    formData.append("type", "login");

    axios.post(`${baseUrl}/customerlogin`,formData)

    .then((res)=>{

        setLoading(false);
  console.log("Response:", res.data);
        if(res.data.token){

            localStorage.setItem("authToken",res.data.token);

            setAuthToken(res.data.token);

            localStorage.setItem("customerLoggedIn","true");

            localStorage.setItem("email",email);
            localStorage.setItem(
    "customer",
    JSON.stringify(res.data.customer)
);

localStorage.setItem("password", res.data.customer.password);
            navigate("/customer-dashboard");

            onLoginSuccess && onLoginSuccess();

        }

    })

    .catch((err)=>{

        setLoading(false);
    

        const message = err.response?.data?.message;

        setErrors({
            email: message === "No account found with this email." ? message : "",
            password: message === "Incorrect password." ? message : ""
        });

    });

};

  // ================= AUTO LOGIN =================
useEffect(() => {

    if (!isOpen) return;

    const email = localStorage.getItem("email");
    const password = localStorage.getItem("password");

    if (email && password) {
        customerAutoLogin(email, password);
    }

}, [isOpen]);
  // Auto login function
const customerAutoLogin = (email, password) => {

    setLoading(true);

    const formData = new FormData();

formData.append("email", email);
formData.append("password", password);
formData.append("type", "autologin");

    axios.post(`${baseUrl}/customerlogin`, formData)

    .then((res) => {

        setLoading(false);

        if (res.data.token) {

            localStorage.setItem("authToken", res.data.token);
            setAuthToken(res.data.token);

            localStorage.setItem("customerLoggedIn", "true");

            navigate("/customer-dashboard");

            onLoginSuccess && onLoginSuccess();
        }

    })

   .catch((err) => {

    setLoading(false);

    console.log("Auto login failed:", err.response?.data);

});

};


  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);


  // Modal band ho to kuch render na karo
  if (!isOpen) return null;

  // ================= INPUT SET FUNCTION =================
  // Form update + error clear
  const set = (key, val) => {
    setForm(p => ({ ...p, [key]: val }));
    setErrors(p => ({ ...p, [key]: "" }));
  };

 const validate = () => {
  const e = {};

  // ===== EMAIL REQUIRED =====
  if (!email.trim()) {
    e.email = "Email is required";
  } else {
    const emailErr = RegExpChecker("email", email);
    if (emailErr.email) e.email = emailErr.email;
  }

  // ===== PASSWORD REQUIRED =====
  if (!password.trim()) {
    e.password = "Password is required";
  } else {
    const passwordErr = RegExpChecker("password", password);
    if (passwordErr.password) e.password = passwordErr.password;
  }

  // ===== SIGNUP FIELDS =====
  if (!isLogin) {

    // Full Name
    if (!fullName.trim()) {
      e.name = "Full name is required";
    } else {
      const nameErr = RegExpChecker("fullName", fullName);
      if (nameErr.fullName) e.name = nameErr.fullName;
    }

    // Phone
    if (!phoneNumber.trim()) {
      e.phone = "Phone number is required";
    } else {
      const phoneErr = RegExpChecker("phone", phoneNumber);
      if (phoneErr.phone) e.phone = phoneErr.phone;
    }

    
  }

  return e;
};

  // ================= FORM SUBMIT =================
const handleSubmit = () => {
  const e = validate();

  // agar errors hain
  if (Object.keys(e).length) {
    setErrors(e);
    return;
  }

  setLoading(true);

  if (isLogin) {
    handleLogin();
  } else {
    handleSignup();
  }
};





  // ================= GOOGLE LOGIN =================
const handleGoogleLogin = () => {

    const type = isLogin ? "login" : "signup";

    window.location.href = `${baseUrl}/auth/google?type=${type}`;

};

  // ================= FORGOT PASSWORD =================
 const handleForgotPassword = () => {
  navigate("/customer-forget-password");
};
  const clearFieldError = (field, value, setter) => {
    setter(value);

    setErrors((prev) => ({
      ...prev,
      [field]: ""
    }));
  };


  return (
    <div className="wh-login-overlay">
      <div className="wh-login-container">
        <div className="wh-login-content">

          {/* Title */}
          <h2 className="wh-login-title">
            {isLogin ? "Welcome Back" : "Create Account"}
          </h2>

          {/* Close button */}
          <button className="wh-login-close" onClick={onClose}>
            <X size={20} />
          </button>

          {/* Form */}
          <form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>

            {/* Signup fields */}
            {!isLogin && (
              <>
                {/* Name */}
                <div className={`field ${errors.name ? 'field--err' : ''}`}>
                  <input
                    className="wh-login-input"
                    placeholder="Full Name"
                    value={fullName}
                    onChange={e => clearFieldError("name", e.target.value, setFullName)}
                  />
                  {errors.name && <span className="err">{errors.name}</span>}
                </div>

                {/* Phone */}
                <div className={`field ${errors.phone ? 'field--err' : ''}`}>
                  <input
                    className="wh-login-input"
                    placeholder="Phone"
                    value={phoneNumber}
                    onChange={e => clearFieldError("phone", e.target.value, setPhoneNumber)}
                  />
                  {errors.phone && <span className="err">{errors.phone}</span>}
                </div>

                {/* City */}

              
              </>
            )}

            {/* Email */}
            <div className={`field ${errors.email ? 'field--err' : ''}`}>
              <input
                className="wh-login-input"
                placeholder="Email"
                value={email}
                onChange={e => clearFieldError("email", e.target.value, setEmail)}

              />
              {errors.email && <span className="err">{errors.email}</span>}
            </div>

            {/* Password */}
            <div className={`field ${errors.password ? 'field--err' : ''}`}>
              <div className="wh-login-password-wrapper">
                <input
                  className="wh-login-input"
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  value={password}
                  onChange={e => clearFieldError("password", e.target.value, setPassword)}

                />
                <span onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </span>
              </div>
              {errors.password && <span className="err">{errors.password}</span>}
            </div>

         

            {/* Submit button */}
            <button className="wh-login-btn-submit" disabled={loading}>
              {loading ? "Please wait..." : isLogin ? "Login" : "Sign Up"}
            </button>

            {/* Google Login */}
            <button
              type="button"
              className="wh-login-btn-google"
              onClick={handleGoogleLogin}
            >
              Continue with Google
            </button>

            {/* Forgot Password */}
            {isLogin && (
              <p className="wh-login-forgot" onClick={handleForgotPassword}>
                Forgot Password?
              </p>
            )}

            {/* Toggle Login/Signup */}
            <p className="wh-login-toggle-text">
              {isLogin ? "No account?" : "Already have account?"}
              <span onClick={() => setIsLogin(!isLogin)}>
                {isLogin ? " Signup" : " Login"}
              </span>
            </p>

          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginModal;